export const NEXT_BLOCK = 'NEXT_BLOCK';
export const SPECIFIC_BLOCK = 'SPECIFIC_BLOCK';
export const GROUP = 'GROUP';
export const END_CHAT = 'END_CHAT';

// export default {
//     NEXT_BLOCK: 'NEXT_BLOCK',
//     SPECIFIC_BLOCK: 'SPECIFIC_BLOCK',
//     GROUP: 'GROUP',
//     END_CHAT: 'END_CHAT',
// };
